webpackJsonp([15],{

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(758),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      VUE_APP_LANDING_PAGE_URL: "https://ponceautomations.com/"
    };
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    dialog: function dialog(val) {
      this.$emit('update:dialog', !!val);
    }
  },
  methods: {
    openPoncePage: function openPoncePage() {
      window.open("https://ponceautomations.com/", '_blank');
    }
  }
});

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "coming-soon-modal"
  }, [_c('v-card-title', [_c('h2', {
    staticClass: "font card-title"
  }, [_vm._v("¡Aviso!")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "font card-text"
  }, [_vm._v("\n      Esto es una funcionalidad solamente disponible en la versión paga."), _c('br'), _vm._v("Conocé más en "), _c('a', {
    on: {
      "click": _vm.openPoncePage
    }
  }, [_vm._v(_vm._s(_vm.VUE_APP_LANDING_PAGE_URL))])])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.d69c63cfed8081c406c0.js